import React, { useRef } from 'react';
import { M0LineModule } from '~/lib/data-contract';
import { useInView } from 'framer-motion';
import { useEffectOnce } from 'react-use';
import { useLineIndex } from './hooks/useLineIndex';
import { useModule } from '~/templates';
import { StyledLine } from './styled';
import { Container } from '../container/container.component';

export const M0Line = ({ spacingBottom, spacingTop, backgroundColor, ...rest }: M0LineModule) => {
    const { element } = useModule<M0LineModule>();
    const { lineIndex, register } = useLineIndex();
    const ref = useRef<HTMLDivElement | null>(null);
    const isInView = useInView(ref, { margin: '0px 0px -20% 0px', once: true });

    useEffectOnce(() => register(element.id));

    return (
        <Container
            {...rest}
            spacingTop={spacingTop ?? 'none'}
            spacingBottom={spacingBottom ?? 'none'}
            aria-hidden="true"
        >
            <StyledLine
                ref={ref}
                inView={isInView}
                index={lineIndex[element.id]}
                color={backgroundColor}
            />
        </Container>
    );
};
